export default __webpack_public_path__ + "static/media/1613568929202-01-removebg-preview.b1d64766.png";